/* MarkdownEditor 樣式 */

/* 編輯器容器樣式 */
.editor-container {
  overflow: auto;
  position: relative;
  height: 100%;
  width: 100%;
}

/* 檔案資訊頭部樣式 - 調整位置避免與工具欄重疊 */
.file-info-header {
  padding: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
  background-color: transparent; /* 改為透明背景 */
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 將內容推到右選 */
  transition: opacity 0.3s ease;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 150; /* 比工具欄的 z-index 更高 */
  height: 40px;
  pointer-events: none; /* 允許點擊穿透到工具欄 */
}

.file-info-header.visible {
  opacity: 1;
}

.file-info-header.hidden {
  opacity: 0;
  pointer-events: none;
}

/* 檔案資訊標題文字樣式 */
.file-info-header h2 {
  pointer-events: auto; /* 允許標題文字可點擊 */
  background-color: rgba(248, 250, 252, 0.8); /* 半透明背景 */
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  margin-left: auto; /* 將標題推到右選 */
  margin-right: 1rem; /* 右側留一些空間 */
}

/* 暗黑模式下的檔案資訊標題 */
@media (prefers-color-scheme: dark) {
  .file-info-header h2 {
    background-color: rgba(30, 41, 59, 0.8);
  }
}

/* 暗黑模式下的樣式 */
@media (prefers-color-scheme: dark) {
  .file-info-header {
    background-color: #1e293b;
    border-color: #334155;
  }
}

/* 全局樣式，用於覆蓋 Vditor 的樣式 */
:root {
  --vditor-toolbar-height: 40px;
}

/* 確保 Vditor 工具欄在最上層且正確顯示 */
.vditor-toolbar {
  position: sticky !important;
  top: 0 !important;
  z-index: 100 !important;
  background-color: #fff !important;
  border-bottom: 1px solid #e2e8f0 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  /* 確保工具欄可見 */
  display: flex !important;
  flex-wrap: wrap !important;
  opacity: 1 !important;
  visibility: visible !important;
  /* 避免閃爍 */
  transition: none !important;
  animation: none !important;
  will-change: transform !important;
  backface-visibility: hidden !important;
  transform: translateZ(0) !important;
  /* 調整工具欄內邊距 */
  padding-right: 120px !important; /* 為檔案資訊標題留出空間 */
}

/* 暗黑模式下的工具欄樣式 */
@media (prefers-color-scheme: dark) {
  .vditor-toolbar {
    background-color: #1e293b !important;
    border-color: #334155 !important;
  }
}

/* 為 Vditor 內容區域添加適當的內邊距，避免被固定工具欄遮擋 */
.vditor-content {
  padding-top: 10px !important;
  margin-top: 0 !important;
  overflow: auto !important;
  /* 避免閃爍 */
  transition: none !important;
  animation: none !important;
  will-change: transform !important;
  backface-visibility: hidden !important;
}

/* 確保 Vditor 編輯區域有正確的高度 */
.vditor {
  height: 100% !important;
  position: relative !important;
  /* 避免閃爍 */
  transition: none !important;
  animation: none !important;
}

/* 確保編輯器容器有正確的層級和定位 */
.editor-container .vditor {
  border: none !important;
}

/* 修復工具欄顯示問題 */
.vditor-toolbar {
  display: flex !important;
  flex-wrap: wrap !important;
}

/* 確保編輯器內容不會閃爍 */
.vditor-wysiwyg, .vditor-ir, .vditor-sv {
  transition: none !important;
  animation: none !important;
}

/* 確保所有編輯器元素不會閃爍 */
.vditor-reset {
  margin-top: 0 !important;
  transition: none !important;
  animation: none !important;
}

/* 確保整個編輯器容器穩定 */
.flex-1.h-full {
  position: relative;
  overflow: hidden;
}
